import React from 'react'

const ViewModeContext = React.createContext()

export default ViewModeContext
